import { UserPermissions } from '@centecomm/portal-service';
import AdministrationNavigationIcon from 'Icons/NavigationItem/Administration';
import React from 'react';
import { Redirect } from 'react-router-dom';

import { FeatureConfiguration } from '../../../Core/Types/FeatureConfiguration';
import communicationSettinsConfigurations from './CommunicationSettings/communicationSettingsConfiguration';
import complianceBuilderConfiguration from './ComplianceBuilder/complianceBuilderConfiguration';
import complianceHubConfiguration from './ComplianceHubSettings/complianceHubSettingsConfiguration';
import documentsSettingsConfiguration from './DocumentsSettings/documentsSettingsConfiguration';
import helpGuidesSettingsConfiguration from './HelpGuidesSettings/helpGuidesSettingsConfiguration';
import hvacComplianceSettingsConfiguration from './HvacComplianceSettings/hvacComplianceSettingsConfiguration';
import insuranceSettingsConfiguration from './InsuranceSettings/insuranceSettingsConfiguration';
import invoicesSettingsConfiguration from './InvoicesSettings/invoicesSettingsConfiguration';
import landingPageSettingsConfiguration from './LandingPageSettings/landingPageSettingsConfiguration';
import leasingSettingsConfiguration from './LeasingSettings/leasingSettingsConfiguration';
import locationSettinsConfigurations from './LocationSettings/locationSettingsConfiguration';
import reportSettingsConfigurations from './ReportSettings/reportSettingsConfiguration';
import requestSettingsConfiguration from './RequestSettings/requestSettingsConfiguration';
import salesSettingsConfiguration from './SalesSettings/salesSettingsConfiguration';

const configurationListItems = [
    landingPageSettingsConfiguration,
    communicationSettinsConfigurations,
    documentsSettingsConfiguration,
    helpGuidesSettingsConfiguration,
    insuranceSettingsConfiguration,
    leasingSettingsConfiguration,
    locationSettinsConfigurations,
    reportSettingsConfigurations,
    requestSettingsConfiguration,
    complianceHubConfiguration,
    complianceBuilderConfiguration,
    salesSettingsConfiguration,
    invoicesSettingsConfiguration,
    hvacComplianceSettingsConfiguration,
] as FeatureConfiguration[];

const childItems = configurationListItems.sort((settingConfigurationA, settingConfigurationB) =>
    settingConfigurationA.name > settingConfigurationB.name ? 1 : -1,
);
const rootRedirection = <Redirect to={childItems[0].navigationItem?.route.url as Required<string>} />;

const systemAdministrationConfiguration: FeatureConfiguration = {
    name: 'administrationFeature:system.title',
    navigationItem: {
        route: {
            text: 'administrationFeature:sidebar.system.title',
            url: '/system-settings',
            Icon: AdministrationNavigationIcon,
            ownerOperatorRoot: rootRedirection,
            tenantRoot: null,
            childItems,
        },
        isGloballyAccessible: false,
        permissions: [UserPermissions.ManageAdminConfig],
    },
    disableFeature: [],
};

export default systemAdministrationConfiguration;
